import { SignJWT } from 'jose';
import { JWT_FORMS_SECRET_KEY } from '@/constants';

interface JwtOptions {
  exp: number;
}

export async function makeJwtFromJSON(json: object, opts: JwtOptions): Promise<string> {
  const secret = new TextEncoder().encode(JWT_FORMS_SECRET_KEY);
  const alg = 'HS512';

  const jwt = await new SignJWT({ ...json })
    .setProtectedHeader({ alg })
    .setIssuedAt()
    .setExpirationTime(opts.exp)
    .sign(secret);

  return jwt;
}
